export default __webpack_public_path__ + "static/media/icon-nicht-geliefert.85bd9cf2.svg";